import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Link } from "react-router-dom";
import Image from "src/components/elements/Image";
import MenuItemTextHighlighter from "src/components/navigation/MenuItemTextHighlighter";
import { isSVGString } from "src/helpers";
import { classNames } from "src/helpers/classNames";
import useDevice from "src/hooks/useDevice";

const TopMenuItemLink = ({ data, image, page_id, menu_id, group_id, searchTerm, mordernDesign, isTopLevel = false, handleClick = () => {} }) => {
  const [imageError, setImageError] = useState(false);
  const device = useDevice();

  const iconImage = () => {
    return (
      <>
        {image && !imageError && (
          <div className={classNames("nav-icon mr-2  flex-shrink-0", data?.headerMenu ? "h-4 w-4" : "h-5 w-5")}>
            {isSVGString(image) ? (
              <div dangerouslySetInnerHTML={{ __html: image.replace(/stroke-width="[^"]*"/g, 'stroke-width="1.7"') }} />
            ) : (
              <Image
                src={image}
                alt="Menu image"
                onError={() => setImageError(true)}
              />
            )}
          </div>
        )}
      </>
    );
  };

  const isHeaderSubMenuActive = Boolean(data?.groupHeaderMenuSub && page_id === data?.slug);

  return (
    <>
      <div className={classNames("relative", data.type !== "internal" ? "group/link" : "", device === "mobile" ? "max-w-80" : "max-w-72")}>
        {data.type === "internal" ? (
          <Link
            onClick={() => handleClick(data.groupId)}
            to={data.link}
            className={classNames(
              "flex min-h-10 w-full select-none items-center justify-start rounded px-3 transition-all",
              !mordernDesign && data?.headerMenu ? "hover:bg-headerMenuActiveBgColor hover:text-headerMenuActiveTextColor" : classNames("py-2 hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor", !mordernDesign ? "" : "!py-0"),
              (
                data.sub
                  ? (data._id === page_id || data.slug === page_id) && data.groupId === group_id
                  : data?.headerMenu
                    ? data._id === menu_id || data.slug === menu_id || isHeaderSubMenuActive
                    : ((data._id === page_id || data.slug === page_id) && !data.groupId && !group_id) || (data.groupId && group_id && data.groupId === group_id && (data._id === page_id || data.slug === page_id))
              )
                ? !mordernDesign && data?.headerMenu
                  ? "bg-headerMenuActiveBgColor text-headerMenuActiveTextColor"
                  : "bg-leftNavActiveColor text-leftNavActiveTextColor"
                : !mordernDesign && data?.headerMenu
                  ? "text-headerTextColor"
                  : "text-leftNavTextColor",
            )}>
            {iconImage()}
            <span
              className={classNames("truncate whitespace-nowrap", isTopLevel ? "font-normal" : "font-medium")}
              title={data.name}>
              <MenuItemTextHighlighter
                text={data.name}
                highlight={searchTerm}
              />
            </span>
          </Link>
        ) : (
          <a
            href={data.link}
            target={data.page_link_newtab ? "_blank" : "_self"}
            rel="noreferrer"
            className={classNames(
              "flex min-h-10 w-full items-center rounded px-2 transition-all ",
              !mordernDesign && data?.headerMenu ? "hover:bg-headerMenuActiveBgColor hover:text-headerMenuActiveTextColor" : "py-1 hover:bg-leftNavActiveColor hover:text-leftNavActiveTextColor hover:underline",
              (data._id === page_id || data.slug === page_id) && !group_id
                ? !mordernDesign && data?.headerMenu
                  ? "bg-headerMenuActiveBgColor text-headerMenuActiveTextColor"
                  : "bg-leftNavActiveColor text-leftNavActiveTextColor"
                : !mordernDesign && data?.headerMenu
                  ? "text-headerTextColor"
                  : "text-leftNavTextColor",
            )}>
            {iconImage()}
            <span className={classNames("whitespace-nowrap", isTopLevel ? "font-normal" : "font-medium")}>
              {" "}
              <MenuItemTextHighlighter
                text={data.name}
                highlight={searchTerm}
              />
            </span>
            {<ArrowTopRightOnSquareIcon className={classNames("ml-2 h-4 w-4 stroke-2 md:h-4 md:w-4")} />}
          </a>
        )}
      </div>
    </>
  );
};

export default TopMenuItemLink;
